/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1Sims, createTKT1Sim, updateTKT1Sim } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';

class TKT1Sim extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'MID',
    sortOrder: 1,
    search: '',
    mobile_network_provider: '',
    status: ''
  }

  initShowColumns = {
    mid: true,
    number: true,
    latest_OTP: true,
    mobile_network_provider: true,
    setup_fee: true,
    monthly_fee: true,
    registered_date: true,
    expired_date: true,
    registered_c3d_number: true,
    status: true,
    ref_etsy_info_pack_mid: true,
    note: true
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      showCreateModal: false,
      showEditModal: false,
      showViewModal: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedSim: null,
      isEditMode: false,
      createFormData: {
        mobile_network_provider: '',
        number: '',
        setup_fee: 0,
        monthly_fee: 0,
        registered_date: '',
        expired_date: '',
        registered_c3d_number: '',
        status: 'ACTIVE',
        ref_etsy_info_pack_mid: '',
        note: ''
      },
      editFormData: {
        mobile_network_provider: '',
        number: '',
        setup_fee: 0,
        monthly_fee: 0,
        registered_date: '',
        expired_date: '',
        registered_c3d_number: '',
        status: 'ACTIVE',
        ref_etsy_info_pack_mid: '',
        note: ''
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Sim';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1Sim_ViewConfig'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1Sims(apiQuery);
      })
    } else {
      // No URL params - use localStorage
      var query = JSON.parse(localStorage.getItem('tkt1_sim_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1Sim_ViewConfig'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1Sims(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1Sims(apiQuery);
        })
      }
    }
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.props.getTKT1Sims(apiQuery);
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleProviderChange = (e) => {
    const newQuery = { ...this.state.query, mobile_network_provider: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_sim_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Sims(apiQuery);
  }

  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_sim_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Sims(apiQuery);
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_sim_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Sims(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_sim_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Sims(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1Sim_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'ACTIVE':
        return 'Hoạt động';
      case 'INACTIVE':
        return 'Không hoạt động';
      case 'SUSPENDED':
        return 'Tạm dừng';
      case 'EXPIRED':
        return 'Hết hạn';
      case 'CANCELLED':
        return 'Hủy';
      default:
        return status;
    }
  }

  // Map provider to Vietnamese
  mapProvider = (provider) => {
    if (!provider) return '-';
    switch (provider.toUpperCase()) {
      case 'VIETTEL':
        return 'Viettel';
      case 'VINAPHONE':
        return 'Vinaphone';
      case 'MOBIFONE':
        return 'Mobifone';
      case 'VIETNAMMOBILE':
        return 'Vietnamobile';
      case 'GMOBILE':
        return 'Gmobile';
      case 'OTHER':
        return 'Khác';
      default:
        return provider;
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Modal handlers
  handleViewClick = (sim) => {
    this.setState({
      showViewModal: true,
      selectedSim: sim,
      isEditMode: false
    });
  }

  handleEditClick = (sim) => {
    this.setState({
      showEditModal: true,
      selectedSim: sim,
      isEditMode: true,
      editFormData: {
        mobile_network_provider: sim.mobile_network_provider || '',
        number: sim.number || '',
        setup_fee: sim.setup_fee || 0,
        monthly_fee: sim.monthly_fee || 0,
        registered_date: sim.registered_date ? 
          new Date(sim.registered_date).toISOString().split('T')[0] : '',
        expired_date: sim.expired_date ? 
          new Date(sim.expired_date).toISOString().split('T')[0] : '',
        registered_c3d_number: sim.registered_c3d_number || '',
        status: sim.status || 'ACTIVE',
        ref_etsy_info_pack_mid: sim.ref_etsy_info_pack_mid || '',
        note: sim.note || ''
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedSim: null,
      isEditMode: false
    });
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      createFormData: {
        mobile_network_provider: '',
        number: '',
        setup_fee: 0,
        monthly_fee: 0,
        registered_date: '',
        expired_date: '',
        registered_c3d_number: '',
        status: 'ACTIVE',
        ref_etsy_info_pack_mid: '',
        note: ''
      }
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedSim: null,
      isEditMode: false,
      editFormData: {
        mobile_network_provider: '',
        number: '',
        setup_fee: 0,
        monthly_fee: 0,
        registered_date: '',
        expired_date: '',
        registered_c3d_number: '',
        status: 'ACTIVE',
        ref_etsy_info_pack_mid: '',
        note: ''
      }
    });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Etsy Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  handleCreateInputChange = (field, value) => {
    this.setState({
      createFormData: {
        ...this.state.createFormData,
        [field]: value
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleCreateSim = async () => {
    const { createFormData } = this.state;
    
    // Validation
    if (!createFormData.number || !createFormData.mobile_network_provider) {
      alert('Vui lòng nhập đầy đủ số điện thoại và nhà mạng');
      return;
    }

    try {
      // Call create action
      await this.props.createTKT1Sim(createFormData);
      
      // Close modal
      this.handleCloseCreateModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1Sims(apiQuery);
      
      alert('Tạo SIM mới thành công!');
    } catch (error) {
      console.error('Error creating sim:', error);
      alert('Lỗi khi tạo SIM mới. Vui lòng thử lại.');
    }
  }

  handleSaveEdit = async () => {
    const { selectedSim, editFormData } = this.state;
    
    if (!selectedSim || !selectedSim._id) {
      alert('Không tìm thấy thông tin Sim để cập nhật');
      return;
    }

    try {
      // Call update action
      await this.props.updateTKT1Sim(selectedSim._id, editFormData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1Sims(apiQuery);
      
      alert('Cập nhật thông tin Sim thành công!');
    } catch (error) {
      console.error('Error updating sim:', error);
      alert('Lỗi khi cập nhật thông tin Sim. Vui lòng thử lại.');
    }
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, search, mobile_network_provider, status, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add provider filter if selected
    if (mobile_network_provider && mobile_network_provider.trim()) {
      apiQuery.mobile_network_provider = mobile_network_provider;
    }
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    // Save to localStorage
    localStorage.setItem('tkt1_sim_query', JSON.stringify(trimmedQuery));
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1Sims(apiQuery);
    })
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery);
    this.props.getTKT1Sims(apiQuery);
    localStorage.setItem('tkt1_sim_query', JSON.stringify(trimmedQuery));
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1-device/sim',
      search: queryStr,
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ sims: [] }, () => {
        this.updateUrl(trimmedQuery);
        this.props.getTKT1Sims(apiQuery);
        localStorage.setItem('tkt1_sim_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="3">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo số điện thoại, C3D..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Nhà mạng</InputGroup.Text>
            <Form.Select
              value={this.state.query.mobile_network_provider}
              onChange={this.handleProviderChange}
            >
              <option value="">Tất cả</option>
              <option value="VIETTEL">Viettel</option>
              <option value="VINAPHONE">Vinaphone</option>
              <option value="MOBIFONE">Mobifone</option>
              <option value="VIETNAMMOBILE">Vietnamobile</option>
              <option value="GMOBILE">Gmobile</option>
              <option value="OTHER">Khác</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="ACTIVE">Hoạt động</option>
              <option value="INACTIVE">Không hoạt động</option>
              <option value="SUSPENDED">Tạm dừng</option>
              <option value="EXPIRED">Hết hạn</option>
              <option value="CANCELLED">Hủy</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="MID">MID</option>
              <option value="number">Số điện thoại</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="registered_date">Ngày đăng ký</option>
              <option value="expired_date">Ngày hết hạn</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderSimTable = () => {
    const { sims } = this.props;
    const { showColumns } = this.state;
    
    // Ensure sims is an array and filter out any null/undefined items
    const safeSims = Array.isArray(sims) ? sims.filter(sim => sim != null && typeof sim === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeSims || safeSims.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.mid && <th>MID</th>}
              {showColumns.number && <th>Số điện thoại</th>}
              {showColumns.latest_OTP && <th>OTP mới nhất</th>}
              {showColumns.mobile_network_provider && <th>Nhà mạng</th>}
              {showColumns.setup_fee && <th>Phí lắp đặt</th>}
              {showColumns.monthly_fee && <th>Phí hàng tháng</th>}
              {showColumns.registered_date && <th>Ngày đăng ký</th>}
              {showColumns.expired_date && <th>Ngày hết hạn</th>}
              {showColumns.registered_c3d_number && <th>Số C3D</th>}
              {showColumns.status && <th>Trạng thái</th>}
              {showColumns.ref_etsy_info_pack_mid && <th>Etsy Info Pack MID</th>}
              {showColumns.note && <th>Ghi chú</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.mid && <th>MID</th>}
            {showColumns.number && <th>Số điện thoại</th>}
            {showColumns.latest_OTP && <th>OTP mới nhất</th>}
            {showColumns.mobile_network_provider && <th>Nhà mạng</th>}
            {showColumns.setup_fee && <th>Phí lắp đặt</th>}
            {showColumns.monthly_fee && <th>Phí hàng tháng</th>}
            {showColumns.registered_date && <th>Ngày đăng ký</th>}
            {showColumns.expired_date && <th>Ngày hết hạn</th>}
            {showColumns.registered_c3d_number && <th>Số C3D</th>}
            {showColumns.status && <th>Trạng thái</th>}
            {showColumns.ref_etsy_info_pack_mid && <th>Etsy Info Pack MID</th>}
            {showColumns.note && <th>Ghi chú</th>}
            <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeSims.map((sim, index) => {
            if (!sim || typeof sim !== 'object') return null;
              
              return (
                <tr key={sim._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.mid && (
                    <td>
                      {sim.MID ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{sim.MID}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(sim.MID)}
                            title="Copy MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.number && (
                    <td>
                      {sim.number ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{sim.number}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(sim.number)}
                            title="Copy Số điện thoại"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.latest_OTP && (
                    <td>
                      {sim.latest_OTP ? (
                        <div>
                          <div className="d-flex align-items-center gap-2">
                            <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                              {sim.latest_OTP}
                            </Badge>
                            <FaCopy
                              size={12}
                              style={{ cursor: 'pointer', color: '#6c757d' }}
                              onClick={() => this.copyToClipboard(sim.latest_OTP)}
                              title="Copy OTP"
                            />
                          </div>
                          {sim.latest_OTP_at && (
                            <small className="text-muted text-nowrap">
                              {new Date(sim.latest_OTP_at).toLocaleString('vi-VN')}
                            </small>
                          )}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.mobile_network_provider && (
                    <td>
                      {sim.mobile_network_provider ? (
                        <Badge 
                          bg={
                            sim.mobile_network_provider === 'VIETTEL' ? 'primary' :
                            sim.mobile_network_provider === 'VINAPHONE' ? 'success' :
                            sim.mobile_network_provider === 'MOBIFONE' ? 'warning' :
                            sim.mobile_network_provider === 'VIETNAMMOBILE' ? 'info' :
                            sim.mobile_network_provider === 'GMOBILE' ? 'secondary' :
                            'dark'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapProvider(sim.mobile_network_provider)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.setup_fee && (
                    <td>
                      {sim.setup_fee ? (
                        <span className="text-success fw-bold">
                          {sim.setup_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.monthly_fee && (
                    <td>
                      {sim.monthly_fee ? (
                        <span className="text-primary fw-bold">
                          {sim.monthly_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.registered_date && (
                    <td>
                      {sim.registered_date ? 
                        new Date(sim.registered_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.expired_date && (
                    <td>
                      {sim.expired_date ? 
                        new Date(sim.expired_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.registered_c3d_number && (
                    <td>
                      {sim.registered_c3d_number ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{sim.registered_c3d_number}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(sim.registered_c3d_number)}
                            title="Copy C3D Number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      {sim.status ? (
                        <Badge 
                          bg={
                            sim.status === 'ACTIVE' ? 'success' :
                            sim.status === 'INACTIVE' ? 'warning' :
                            sim.status === 'SUSPENDED' ? 'info' :
                            sim.status === 'EXPIRED' ? 'danger' :
                            sim.status === 'CANCELLED' ? 'dark' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(sim.status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {sim.ref_etsy_info_pack_mid ? (
                        <Badge 
                          bg="success" 
                          style={{ 
                            fontSize: '0.8em', 
                            padding: '4px 8px', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => this.handleEtsyInfoPackClick(sim.ref_etsy_info_pack_mid)}
                          title="Click để xem chi tiết Etsy Info Pack"
                        >
                          {sim.ref_etsy_info_pack_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={sim.note}>
                        {sim.note || '-'}
                      </div>
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(sim)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(sim)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Sim
              </h2>
            </Col>
            <Col className="text-end">
              <Button 
                variant="success" 
                onClick={() => this.setState({ showCreateModal: true })}
                className="me-2"
              >
                <i className="fas fa-plus me-1"></i>
                Thêm SIM mới
              </Button>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.renderSimTable()}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    number: 'Số điện thoại',
                    mobile_network_provider: 'Nhà mạng',
                    setup_fee: 'Phí lắp đặt',
                    monthly_fee: 'Phí hàng tháng',
                    registered_date: 'Ngày đăng ký',
                    expired_date: 'Ngày hết hạn',
                    registered_c3d_number: 'Số C3D',
                    status: 'Trạng thái',
                    mid: 'MID',
                    latest_OTP: 'OTP mới nhất',
                    ref_etsy_info_pack_mid: 'Etsy Info Pack MID',
                    note: 'Ghi chú'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Sim</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedSim && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Số điện thoại:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedSim.number}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Nhà mạng:</strong> 
                    <div className="mt-1">
                      {this.state.selectedSim.mobile_network_provider ? (
                        <Badge 
                          bg={
                            this.state.selectedSim.mobile_network_provider === 'VIETTEL' ? 'primary' :
                            this.state.selectedSim.mobile_network_provider === 'VINAPHONE' ? 'success' :
                            this.state.selectedSim.mobile_network_provider === 'MOBIFONE' ? 'warning' :
                            this.state.selectedSim.mobile_network_provider === 'VIETNAMMOBILE' ? 'info' :
                            this.state.selectedSim.mobile_network_provider === 'GMOBILE' ? 'secondary' :
                            'dark'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapProvider(this.state.selectedSim.mobile_network_provider)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Financial Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tài chính</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Phí lắp đặt:</strong> 
                    <div className="mt-1">
                      {this.state.selectedSim.setup_fee ? (
                        <span className="text-success fw-bold">
                          {this.state.selectedSim.setup_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Phí hàng tháng:</strong> 
                    <div className="mt-1">
                      {this.state.selectedSim.monthly_fee ? (
                        <span className="text-primary fw-bold">
                          {this.state.selectedSim.monthly_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Date Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin ngày tháng</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày đăng ký:</strong> 
                    <div className="mt-1">
                      {this.state.selectedSim.registered_date ? 
                        new Date(this.state.selectedSim.registered_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày hết hạn:</strong> 
                    <div className="mt-1">
                      {this.state.selectedSim.expired_date ? 
                        new Date(this.state.selectedSim.expired_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* C3D Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin C3D</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Số C3D:</strong> 
                    <div className="mt-1">{this.state.selectedSim.registered_c3d_number || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedSim.MID ? (
                        <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {this.state.selectedSim.MID}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Etsy Info Pack MID:</strong> 
                    <div className="mt-1">{this.state.selectedSim.ref_etsy_info_pack_mid || '-'}</div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedSim.status ? (
                        <Badge 
                          bg={
                            this.state.selectedSim.status === 'ACTIVE' ? 'success' :
                            this.state.selectedSim.status === 'INACTIVE' ? 'warning' :
                            this.state.selectedSim.status === 'SUSPENDED' ? 'info' :
                            this.state.selectedSim.status === 'EXPIRED' ? 'danger' :
                            this.state.selectedSim.status === 'CANCELLED' ? 'dark' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedSim.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* OTP Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin OTP</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>OTP mới nhất:</strong>
                    <div className="mt-1 d-flex align-items-center gap-2">
                      {this.state.selectedSim.latest_OTP ? (
                        <>
                          <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                            {this.state.selectedSim.latest_OTP}
                          </Badge>
                          <FaCopy
                            size={14}
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedSim.latest_OTP)}
                            title="Copy OTP"
                          />
                        </>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Thời gian nhận OTP:</strong>
                    <div className="mt-1">
                      {this.state.selectedSim.latest_OTP_at ?
                        new Date(this.state.selectedSim.latest_OTP_at).toLocaleString('vi-VN') :
                        '-'
                      }
                    </div>
                  </Col>
                </Row>

                {/* Additional Information */}
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong>
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedSim.note || '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm SIM mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số điện thoại <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.number}
                      onChange={(e) => this.handleCreateInputChange('number', e.target.value)}
                      placeholder="Nhập số điện thoại"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nhà mạng <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      value={this.state.createFormData.mobile_network_provider}
                      onChange={(e) => this.handleCreateInputChange('mobile_network_provider', e.target.value)}
                      required
                    >
                      <option value="">Chọn nhà mạng</option>
                      <option value="VIETTEL">Viettel</option>
                      <option value="VINAPHONE">Vinaphone</option>
                      <option value="MOBIFONE">Mobifone</option>
                      <option value="VIETNAMMOBILE">Vietnamobile</option>
                      <option value="GMOBILE">Gmobile</option>
                      <option value="OTHER">Khác</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phí lắp đặt (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.createFormData.setup_fee}
                      onChange={(e) => this.handleCreateInputChange('setup_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí lắp đặt"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phí hàng tháng (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.createFormData.monthly_fee}
                      onChange={(e) => this.handleCreateInputChange('monthly_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí hàng tháng"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày đăng ký</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.createFormData.registered_date}
                      onChange={(e) => this.handleCreateInputChange('registered_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày hết hạn</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.createFormData.expired_date}
                      onChange={(e) => this.handleCreateInputChange('expired_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số C3D</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.registered_c3d_number}
                      onChange={(e) => this.handleCreateInputChange('registered_c3d_number', e.target.value)}
                      placeholder="Nhập số C3D"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.status}
                      onChange={(e) => this.handleCreateInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="SUSPENDED">Tạm dừng</option>
                      <option value="EXPIRED">Hết hạn</option>
                      <option value="CANCELLED">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Etsy Info Pack MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleCreateInputChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập Etsy Info Pack MID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.createFormData.note}
                      onChange={(e) => this.handleCreateInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              Hủy
            </Button>
            <Button variant="success" onClick={this.handleCreateSim}>
              <i className="fas fa-plus me-1"></i>
              Tạo SIM mới
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Sim</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số điện thoại</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.number}
                      onChange={(e) => this.handleEditInputChange('number', e.target.value)}
                      placeholder="Nhập số điện thoại"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nhà mạng</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.mobile_network_provider}
                      onChange={(e) => this.handleEditInputChange('mobile_network_provider', e.target.value)}
                    >
                      <option value="">Chọn nhà mạng</option>
                      <option value="VIETTEL">Viettel</option>
                      <option value="VINAPHONE">Vinaphone</option>
                      <option value="MOBIFONE">Mobifone</option>
                      <option value="VIETNAMMOBILE">Vietnamobile</option>
                      <option value="GMOBILE">Gmobile</option>
                      <option value="OTHER">Khác</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phí lắp đặt (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.setup_fee}
                      onChange={(e) => this.handleEditInputChange('setup_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí lắp đặt"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phí hàng tháng (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.monthly_fee}
                      onChange={(e) => this.handleEditInputChange('monthly_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí hàng tháng"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày đăng ký</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.registered_date}
                      onChange={(e) => this.handleEditInputChange('registered_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày hết hạn</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.expired_date}
                      onChange={(e) => this.handleEditInputChange('expired_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số C3D</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.registered_c3d_number}
                      onChange={(e) => this.handleEditInputChange('registered_c3d_number', e.target.value)}
                      placeholder="Nhập số C3D"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="SUSPENDED">Tạm dừng</option>
                      <option value="EXPIRED">Hết hạn</option>
                      <option value="CANCELLED">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Etsy Info Pack MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleEditInputChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập Etsy Info Pack MID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sims: state.tkt1SimReducer.sims,
    totalCount: state.tkt1SimReducer.totalCount
  };
};

export default connect(mapStateToProps, { getTKT1Sims, createTKT1Sim, updateTKT1Sim })(TKT1Sim);
